const locale = {
  zh_CN: {
    YS_FED_FW_YONUI_00050006: '暂无数据~',
    YS_FED_FW_YONUI_00050005: '请输入您的手机号',
    YS_FED_FW_YONUI_00050004: '√',
    YS_FED_FW_YONUI_00050003: '中国',
    YS_FED_FW_YONUI_00050002: '确认',
    YS_FED_FW_YONUI_00050001: '取消',
    YS_FED_FW_YONUI_00050000: '条/页'
  },
  zh_TW: {
    YS_FED_FW_YONUI_00050006: '暫無數據~',
    YS_FED_FW_YONUI_00050005: '請輸入您的手機號',
    YS_FED_FW_YONUI_00050004: '√',
    YS_FED_FW_YONUI_00050003: '中國',
    YS_FED_FW_YONUI_00050002: '確認',
    YS_FED_FW_YONUI_00050001: '取消',
    YS_FED_FW_YONUI_00050000: '條/頁'
  },
  en_US: {
    YS_FED_FW_YONUI_00050006: 'No data',
    YS_FED_FW_YONUI_00050005: 'Enter Mobile account',
    YS_FED_FW_YONUI_00050004: '√',
    YS_FED_FW_YONUI_00050003: 'China',
    YS_FED_FW_YONUI_00050002: 'Confirm',
    YS_FED_FW_YONUI_00050001: 'Cancel',
    YS_FED_FW_YONUI_00050000: 'per page'
  },
  de_DE: {
    YS_FED_FW_YONUI_00050006: '暂无数据~',
    YS_FED_FW_YONUI_00050005: '请输入您的手机号',
    YS_FED_FW_YONUI_00050004: '√',
    YS_FED_FW_YONUI_00050003: '中国',
    YS_FED_FW_YONUI_00050002: '确认',
    YS_FED_FW_YONUI_00050001: '取消',
    YS_FED_FW_YONUI_00050000: '条/页'
  },
  fr_FR: {
    YS_FED_FW_YONUI_00050006: '暂无数据~',
    YS_FED_FW_YONUI_00050005: '请输入您的手机号',
    YS_FED_FW_YONUI_00050004: '√',
    YS_FED_FW_YONUI_00050003: '中国',
    YS_FED_FW_YONUI_00050002: '确认',
    YS_FED_FW_YONUI_00050001: '取消',
    YS_FED_FW_YONUI_00050000: '条/页'
  }
}

module.exports = locale
//  {

//   getLocale:(key)=>{
//     return ""//locale[cb.lang.lang][key]
//   }
// }
